import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ReadStateOrDefault } from "source/app/services/UI/State/ReadState";
import { SubscribeToSharedState } from "source/app/services/UI/State/ShareState";

export function useFontSwitcher() {
    const [useAnopenscrollFont, setUseAnopenscrollFont] = React.useState(
        ReadStateOrDefault(
            ESharedFunction.FontSwitcher_useAnopenscrollFont,
            false
        )
    );

    SubscribeToSharedState(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        setUseAnopenscrollFont
    );

    return useAnopenscrollFont;
}
